import { Component, Inject, Input, OnInit } from '@angular/core';
import { CaseModel } from '@app/ps/models/case.model';
import { StateService } from '@uirouter/angular';
import { CaseStatusService } from '@app/ps/services/case-status.service';
import { Restangular } from 'ngx-restangular';
import { APP_BRAND } from '@app/common/services/config.service';
import { CaseService } from '@app/ps/services/case.service';
import {DialogService} from "@app/common/services/dialog.service";

@Component({
  selector: 'sign-administrator',
  templateUrl: './sign-administrator.component.html',
})
export class SignAdministratorComponent implements OnInit {

  @Input() caseId: number;
  loading = true;
  data: CaseModel;
  name: string;
  existsAcquisitionDeed = false;
  flow;

  constructor(
    private stateService: StateService,
    private restangular: Restangular,
    private caseStatusService: CaseStatusService,
    private caseService: CaseService,
    private dialogService: DialogService,
    @Inject(APP_BRAND) private APP_BRAND: any,
  ) {
    this.onSubmit = this.onSubmit.bind(this);
    this.isValid = this.isValid.bind(this);
    this.onDateCheck = this.onDateCheck.bind(this);
  }

  async ngOnInit() {
    this.data = await this.restangular.one('cases', this.caseId).get({loadCollections: ['caseSubjects', 'caseOwnerships', 'constructionObjects']}).toPromise();
    this.name = (await this.caseStatusService.loadStatusName('SignedAdministrator')).name;

    if (this.APP_BRAND.NAME === 'RSD') {
      this.existsAcquisitionDeed = await this.caseService.existsAcquisitionDeed(this.caseId);
      this.flow = await this.caseService.getFlow(this.data);
    }

    this.data.signedAdministratorDate = this.data.signedAdministratorDate || (this.APP_BRAND.NAME === 'RSD' ? null : new Date());
    this.loading = false;
    this.onDateCheck();
  }

  isValid() {
    return !!this.data.signedAdministratorDate && !this.aquisionDeedNeeded();
  }

  onDateCheck(signedDate?: string) {
    if (this.aquisionDeedNeeded() && this.data.signedAdministratorDate) {
      this.caseService.acquisitionDeedNeeded(this.caseId);

      const msg = `Datum podpisu nelze vložit. V dokumentech k případu chybí nabývací listina. Nedojde ke změně stavu případu.`;
      this.dialogService.alertDialogPromise(msg)
        .then(() => {
          this.data.signedAdministratorDate = undefined;
        });
    }
  }

  async onSubmit(): Promise<any> {
    const sendData = {
      signedAdministratorDate: this.data.signedAdministratorDate,
    };
    await this.restangular
      .one('cases', this.caseId)
      .customPUT(sendData, 'sign-administrator')
      .toPromise();
    this.stateService.go('^');
  }

  aquisionDeedNeeded() {
    const whitelist = [
      'FulfillmentOfDecisionExpropriationLiability',
      'TemporaryExpropriationLiability',
      'FulfillmentOfDecisionAuctionSaleExecutionLiability',
    ];
    if (this.APP_BRAND.NAME !== 'RSD' || whitelist.includes(this.data.obligation.type)) {
      return false;
    }
    return this.caseService.isSignedAll(this.flow, this.data) && !this.existsAcquisitionDeed;
  }
}
